export default function formatPhone(phoneStr) {
  const trimmedPhoneStr = phoneStr.trim();
  if (isProperlyFormatted(trimmedPhoneStr)) return trimmedPhoneStr;
  let phoneDigits = trimmedPhoneStr.replace(/\D/g, "");
  let newPhoneStr = "+7";
  if (phoneDigits[0]) {
    if (phoneDigits[0] === "9") phoneDigits = "7" + phoneDigits;
    else if (phoneDigits[0] === "8") phoneDigits = "7" + phoneDigits.slice(1);
  }
  const digit1 = phoneDigits[1];
  if (digit1) newPhoneStr += `(${digit1}`;
  const digit2 = phoneDigits[2];
  if (digit2) newPhoneStr += `${digit2}`;
  const digit3 = phoneDigits[3];
  if (digit3) newPhoneStr += `${digit3}`;
  const digit4 = phoneDigits[4];
  if (digit4) newPhoneStr += `) ${digit4}`;
  const digit5 = phoneDigits[5];
  if (digit5) newPhoneStr += `${digit5}`;
  const digit6 = phoneDigits[6];
  if (digit6) newPhoneStr += `${digit6}`;
  const digit7 = phoneDigits[7];
  if (digit7) newPhoneStr += `-${digit7}`;
  const digit8 = phoneDigits[8];
  if (digit8) newPhoneStr += `${digit8}`;
  const digit9 = phoneDigits[9];
  if (digit9) newPhoneStr += `-${digit9}`;
  const digit10 = phoneDigits[10];
  if (digit10) newPhoneStr += `${digit10}`;
  return newPhoneStr;
}

function isProperlyFormatted(phoneStr) {
  // Don't know how to regex it
  const rules = ["+", "7", "(", "9", "d", "d", ")", " ", "d", "d", "d", "-", "d", "d", "-", "d", "d"];
  const length = phoneStr.length;
  if (length === 0) return true;
  if (length > 17) return false;
  for (let i = 0; i < length; i++) {
    if (!checkRule(phoneStr[i], rules[i])) return false;
  }
  return true;
}

function checkRule(symbol, ruleSymbol) {
  if (ruleSymbol !== "d") return symbol === ruleSymbol;
  const isDigit = new RegExp(/[0-9]/);
  return isDigit.test(symbol);
}
